import React from "react";
import { useTranslation } from "react-i18next";
import { useMachine } from "@xstate/react";
import { Box } from "@mui/material";
import { PageLayout } from "@components";
import { LoadingProgressBar } from "@rentablo/components";
import { useMyself } from "@api/v1/hooks/useMyself";
import { netfondsConsentSM } from "./stateMachine/netfondsConsentSM";
import { ActivateOrDeactivate } from "./components/ActivateOrDeactivate";
import { Deactivated } from "./components/Deactivated";
import { AccountHolderSettings } from "./components/AccountHolderSettings";
import { ImportingData } from "./components/ImportingData";
import { DeleteAccounts } from "./components/DeleteAccounts";

export interface Props {}

export const CashbackImportPage = () => {
  const [currentState, sendEvent] = useMachine(netfondsConsentSM);
  useMyself(); // make sure user is logged in

  const { t } = useTranslation();
  return (
    <PageLayout
      breadcrumbs={[
        { to: "/", text: t("breadcrumbs.home") },
        { text: t("netfondsConsent.breadcrumbs.title") },
      ]}
    >
      <title>{t("netfondsConsent.title")}</title>

      <Box maxWidth={800}>
        {(currentState.matches("idle") ||
          currentState.matches("batchActivate") ||
          currentState.matches("batchDeactivate")) && <LoadingProgressBar />}
        {currentState.matches("activateOrDeactivate") && (
          <ActivateOrDeactivate sendEvent={sendEvent} />
        )}
        {currentState.matches("deleteAccounts") && (
          <DeleteAccounts sendEvent={sendEvent} />
        )}
        {currentState.matches("deactivated") && (
          <Deactivated sendEvent={sendEvent} />
        )}
        {currentState.matches("accountHolderSettings") && (
          <AccountHolderSettings
            sendEvent={sendEvent}
            accountHolders={currentState.context.accountHolders || []}
          />
        )}
        {currentState.matches("importingData") && (
          <ImportingData
            status="inProgress"
            depots={currentState.context.depots || []}
          />
        )}
        {currentState.matches("backToDashboard") && (
          <ImportingData
            status="success"
            depots={currentState.context.depots || []}
          />
        )}
        {currentState.matches("somethingWrong") && (
          <ImportingData
            status="error"
            depots={currentState.context.depots || []}
            errorMessage={currentState.context.error?.message}
          />
        )}
      </Box>
    </PageLayout>
  );
};
